/* document.addEventListener("DOMContentLoaded", function () {
  const checkoutButton = document.querySelector('button[id="checkout-pay-button"]');

  if (checkoutButton) {
    checkoutButton.addEventListener("click", function (e) {
      const cityInput = document.querySelector('input[name="city"]');

      if (cityInput) {
        const city = cityInput.value.toLowerCase();

        if (city !== "bogotá" && city !== "bogota" && city !== "medellín" && city !== "medellin") {
          e.preventDefault();
          alert("Solo enviamos a Medellín y Bogotá.");
        }
      }
    });
  }
}); */

document.addEventListener("DOMContentLoaded", function () {
  const cityInput = document.querySelector('input[name="city"]');

  console.log("Script inline cargado");
  if (cityInput) {
    cityInput.addEventListener("blur", function () {
      const city = cityInput.value.toLowerCase();

      if (
        city !== "bogotá" &&
        city !== "bogota" &&
        city !== "medellín" &&
        city !== "medellin"
      ) {
        alert("Solo enviamos a Medellín y Bogotá.");
        cityInput.focus(); // opcional: devolver el foco al input
      }
    });
  }
});